import { useEffect, useState } from "react";

/* useFullScreenChange: listen for fullscreenchange events and return the fullScreenChange state value */
export const useFullScreenChange = () => {
  const [fullScreenChange, setFullScreenChange] = useState<boolean>(false);

  const exitHandler = () => {
    setFullScreenChange(prevState => !prevState);
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', exitHandler);
    document.addEventListener('webkitfullscreenchange', exitHandler);
    document.addEventListener('mozfullscreenchange', exitHandler);
    document.addEventListener('MSFullscreenChange', exitHandler);

    return () => {
      document.removeEventListener('fullscreenchange', exitHandler);
      document.removeEventListener('webkitfullscreenchange', exitHandler);
      document.removeEventListener('mozfullscreenchange', exitHandler);
      document.removeEventListener('MSFullscreenChange', exitHandler);
    };
  }, []);
  return fullScreenChange;
};
